import React, { useState } from 'react';

export default function ForgotPassword({ navigate }) {
  const [email, setEmail] = useState('');
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState('');

  const submit = async e => {
    e.preventDefault();
    setLoading(true); setErr('');
    try {
      const res = await fetch('/api/auth/forgot-password', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email })
      });
      const data = await res.json();
      if (res.ok) setSent(true);
      else setErr(data.error);
    } catch { setErr('Connection failed.'); }
    setLoading(false);
  };

  if (sent) return (
    <div className="auth-wrap">
      <div className="auth-card fade-in" style={{ textAlign: 'center' }}>
        <div style={{ fontSize: 48, marginBottom: 16 }}>📧</div>
        <div style={{ fontFamily: 'var(--ff-d)', fontSize: 20, fontWeight: 800, marginBottom: 8 }}>Check your email</div>
        <div style={{ color: 'var(--text2)', fontSize: 14, marginBottom: 24, lineHeight: 1.6 }}>
          If <strong style={{ color: 'var(--gold-2)' }}>{email}</strong> is registered, a password reset link has been sent. Check your inbox (and spam folder).
        </div>
        <div style={{ fontSize: 12, color: 'var(--text3)', marginBottom: 20 }}>
          No SMTP configured? Check the server console for the reset link.
        </div>
        <button className="btn btn-ghost btn-sm" onClick={() => navigate('/login')}>← Back to Login</button>
      </div>
    </div>
  );

  return (
    <div className="auth-wrap">
      <div className="auth-card fade-in">
        <div className="auth-logo">
          <span style={{ fontSize: 36 }}>🧬</span>
          <div style={{ fontFamily: 'var(--ff-d)', fontSize: 20, fontWeight: 800, marginTop: 6 }}>Enpower Org DNA™</div>
        </div>
        <h2 className="auth-title">Reset your password</h2>
        <p className="auth-sub">Enter your email and we'll send you a reset link</p>

        <form onSubmit={submit}>
          <div className="form-group">
            <label className="form-label">Email Address</label>
            <input className="form-input" type="email" placeholder="you@company.com" value={email}
              onChange={e => setEmail(e.target.value)} required />
          </div>
          {err && <div className="form-error" style={{ marginBottom: 14 }}>{err}</div>}
          <button className="btn btn-primary" style={{ width: '100%', padding: '11px' }} disabled={loading}>
            {loading ? 'Sending...' : 'Send Reset Link'}
          </button>
        </form>

        <div className="auth-footer">
          <span className="auth-link" onClick={() => navigate('/login')}>← Back to Login</span>
        </div>
      </div>
    </div>
  );
}
